export default __webpack_public_path__ + "static/media/027-analyzer.6f9a3eaf.svg";